// 租户
export default [{ // 租户管理
  path: '/tenantManager',
  name: 'tenantManager',
  component: resolve => require(['@/views/tenantManager/tenantManager.vue'], resolve),
  meta: {
    group: "/tenantManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 新增租户
  path: '/addTenant',
  name: 'addTenant',
  component: resolve => require(['@/views/tenantManager/addTenant.vue'], resolve),
  meta: {
    group: "/tenantManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 编辑租户
  path: '/editTenant',
  name: 'editTenant',
  component: resolve => require(['@/views/tenantManager/addTenant.vue'], resolve),
  meta: {
    group: "/tenantManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/tenantManager/tenantManager.js